var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21777 11.0025L19.2323 5.21343C19.9292 4.96167 20.5378 5.38343 20.312 6.43718L20.3133 6.43588L17.7568 18.48C17.5674 19.3339 17.06 19.5415 16.3501 19.1392L12.457 16.27L10.5792 18.079C10.3715 18.2866 10.1963 18.4618 9.79406 18.4618L10.0705 14.4999L17.2858 7.98146C17.5998 7.70504 17.2157 7.54932 16.8017 7.82444L7.88512 13.4384L4.04128 12.2393C3.20685 11.9745 3.18868 11.4048 4.21777 11.0025V11.0025Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.47c4cf5a.svg";
export { ForwardRef as ReactComponent };